import type { IncludeExtrasRule } from 'src/types';
import fillCrudMetadataGaps from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
import { niaraPaymentOptions } from '../supplierPaymentRule';
export default fillCrudMetadataGaps({
  label: 'Faturamento de extras',
  labelPlural: 'Faturamento de extras',
  name: 'IncludeExtrasRule',
  namePlural: 'IncludeExtrasRules',
  custom_blockRecord: true,
  authorization: authorization('consultant', 'admin'),
  deletable: false,
  dynamoDB: {
    tableName: 'SpearIncludeExtrasRule'
  },
  columns: ['id', 'name', 'enabled'],
  fields: [{
    label: 'Id',
    name: 'id',
    type: 'text',
    updatable: false,
    insertable: false,
    id: true,
    renderColumn: false
  }, {
    name: 'name',
    label: 'Nome',
    type: 'text',
    required: true
  }, {
    name: 'enabled',
    label: 'Ativo',
    default: false,
    required: true,
    type: 'boolean'
  }, {
    label: 'Regras de conteúdo',
    name: 'content',
    type: 'object',
    hint: 'Lista de hotéis que aceitam ou rejeitam faturamento de extras',
    custom_renderFieldsRecursively: true,
    fields: [{
      name: 'type',
      label: 'Tipo da Regra',
      inputType: 'select',
      options: [{
        label: 'Permitir',
        value: 'ALLOW'
      }, {
        label: 'Negar',
        value: 'DENY'
      }]
    }, {
      name: 'value',
      label: 'Conteúdo',
      type: 'objectarray',
      fields: [{
        name: 'id',
        label: 'ID'
      }, {
        name: 'name',
        label: 'Nome'
      }],
      inputType: 'InputMultiHotelAutoComplete'
    }]
  }, {
    name: 'paymentOptionTypes',
    label: 'Formas de recebimento',
    type: 'textarray',
    default: ['INT_OFF_FAT'],
    options: niaraPaymentOptions.filter(op => !op?.value?.endsWith('LATER')),
    hint: 'Para quais tipos de recebimento pode-se solicitar o faturamento de extras'
  }, {
    name: 'supplierPaymentTypes',
    label: 'Formas de pagamento ao fornecedor',
    type: 'textarray',
    default: ['OFF_FAT', 'INT_OFF_FAT'],
    options: [{
      label: 'Faturado offline',
      value: 'OFF_FAT'
    }, {
      label: 'Faturado (front-front)',
      value: 'INT_OFF_FAT'
    }],
    hint: 'Para quais tipos de pagamento pode-se solicitar o faturamento de extras - só permite Faturado offline'
  }, {
    name: 'suppliers',
    label: 'Fornecedores',
    type: 'textarray',
    default: ['OMNI'],
    options: [{
      value: 'OMNI',
      label: 'Omnibees'
    }, {
      value: 'NIAR',
      label: 'Niara'
    }],
    hint: 'Para quais fornecedores pode-se solicitar o faturamento de extras'
  }, {
    name: 'useSupplierIncludeExtraOptions',
    label: 'Respeitar opções de extra do fornecedor',
    default: false,
    type: 'boolean',
    hint: 'Apenas Niara (front front)'
  }, {
    name: `includeExtrasOptions`,
    label: 'Opções de extras incluídos',
    type: 'objectarray',
    graphQLType: '[NestedIncludeExtras]',
    graphQLInputType: '[NestedIncludeExtrasInput]',
    default: [],
    fields: [{
      name: 'id',
      label: 'Código',
      required: true
    }, {
      name: 'label',
      label: 'Nome',
      required: true
    }],
    renderForm: e => e?.useSupplierIncludeExtraOptions !== true
  }],
  filter: [{
    name: 'enabled_eq',
    field: 'enabled',
    op: 'eq'
  }]
});